import gql from "graphql-tag";

const ObservationProps = gql`
    fragment ObservationProps on HealthObservation {
        id
        consent
        created_at
        date
        nextDate
        glasgow {
            eye
            motor
            verbal
        }
        observation {
            bmi
            height
            weight
            more {
                key
                value
            }
        }
        qRisk {
            comment
            score
            taken
        }
        rationale
        tranquilization {
            selected
            taken
        }
        author {
            id
            surname
            first_name
            middle_name
            designation {
                id
                name
            }
        }
        smoke {
            status
            noCigaret
            offeredCessation
            outcome
            reasonForNo
        }
    }
`;

export const GET_OBSERVATION = gql`
    query GetObservation($id: ID!) {
        GetHealthObservations(id: $id) {
            docs {
                ...ObservationProps
            }
        }
    }
    ${ObservationProps}
`;

export const NEW_OBSERVATION = gql`
    mutation NewObservation($model: InputHealthObservation!) {
        NewHealthObservation(model: $model) {
            message
            doc {
                ...ObservationProps
            }
        }
    }
    ${ObservationProps}
`;
